<template>
    <rect class="pulse-rect"
          ref="pulseRect"
          :id="id"
          :width = "rectWidthPercentage"
          :height = "rectHeightPercentage"
          :style = "{'fill': color}"
          :x = "x"
          :y = "y">
    </rect>
</template>

<script>
    export default {
        name: "pulse-rect",
        props: {
            id: {
                type: String,
                required: true
            },
            rectWidthPercentage: {
                type: String,
                required: true
            },
            rectHeightPercentage: {
                type: String,
                required: true
            },
            color: {
                type: String,
                required: true
            },
            x: {
                type: String,
                required: true
            },
            y: {
                type: String,
                required: true
            }
        },
        methods: {
            removeAfterAnimation() {
                var self = this;
                setTimeout(function() {
                    self.$emit("animationOver", self.id);
                }, 1000);
            }
        },
        mounted() {
            this.removeAfterAnimation();
        }
    }
</script>

<style>

    .pulse-rect {
        pointer-events: none;
        opacity: 1;
        animation-duration: 0.75s;
        animation-name: pulse;
        animation-iteration-count: 1;

        /*-webkit-transform-origin: 50% 50%;*/
        /*-moz-transform-origin: 50% 50%;*/
        /*transform-origin: 50% 50%;*/

        -webkit-animation-fill-mode: forwards;  /* it works with Chrome */
        -moz-animation-fill-mode: forwards;  /* works with Mozilla Firefox */
        -ms-animation-fill-mode: forwards;  /* works with IE */
        -o-animation-fill-mode: forwards;  /* works with Opera */
        animation-fill-mode: forwards;  /* should work with all browser .... in theory */
    }

    @keyframes pulse {
        0% {
            width: 0.3125vw;
            height: 0.6vh;
            opacity: 1;
            transform: translate(0,0);
        }
        100% {
            width: 3.125vw;
            height: 6vh;
            opacity: 0;
            transform: translate(-1.4vw, -2.9vh);
        }
    }


</style>



// WEBPACK FOOTER //
// src/components/world-map/PulseRect.vue